<script>
import { mapGetters, mapActions } from "vuex";
import { debounce } from "../../../state/helpers";
import { formatIST } from "../../../config/moment";
// import { param } from "express/lib/request";
/**
 * Add-product component
 */
export default {
  data() {
    return {
      sortBy: "id",
      perPages: 5,
      sortDesc: true,
      page: 1,
      paginations: {},
      limit: 10,
      search: "",
      formatIST,
      id: "",
      booking: {
        is_cancel: [],
      },
      searchData: debounce(() => {
        this.getUpcomingBookings();
        this.init = false;
      }, 500),
      fields: [
        {
          key: "id",
          sortable: true,
          label: "#",
        },
        {
          key: "station",
          sortable: true,
          label: "Charging Stations",
        },
        {
          key: "start_time",
          sortable: true,
          label: "Start Time",
        },
        {
          key: "end_time",
          sortable: true,
          label: "End Time",
        },
        {
          key: "minutes",
          sortable: true,
          label: "Minutes",
        },
        {
          key: "users",
          sortable: true,
          label: "User",
        },
        {
          key: "is_cancel",
          sortable: false,
          label: "Cancel ?",
        },
        {
          key: "info",
          sortable: true,
          label: "Info",
        },
      ],
    };
  },
  props: ["userId"],
  components: {},
  validations: {},
  computed: {
    ...mapGetters("booking", [
      "getAllUpcomingBooking",
      "getAllBookingInfo",
      "loading",
      "upComingBookingCount",
      "pagination",
    ]),
  },
  mounted() {
    this.getUpcomingBookings();
  },
  methods: {
    ...mapActions("booking", [
      "getUpcomingBooking",
      "getUpcomingBookingOnOff",
      "getBooking",
    ]),
    getUpcomingBookings(page = 1) {
      var filters = {
        search: this.search,
        sortBy: this.sortBy,
        orderBy: this.sortDesc ? "desc" : "asc",
        page: page && page > 0 ? page : 1,
        perPages: this.perPages,
      };
      this.getUpcomingBooking(filters);
    },
    onStatusChange(event) {
      if (
        confirm("Are You Sure to Cancel #" + event.target.value + " Booking")
      ) {
        this.is_cancel = event.target.checked ? "1" : "0";
        var data = {
          id: event.target.value,
          is_cancel: this.is_cancel,
          cancellation_reason: 1,
        };
        this.getUpcomingBookingOnOff(data);
      } else {
        event.target.checked = false;
      }
    },
    getBookingInfo(booking_id) {
      var data = {
        id: booking_id,
      };
      this.getBooking(data).then(() => {
        this.$bvModal.show("bv-modal-booking-info");
      });
    },
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.getUpcomingBookings();
    },
    resetForm() {
      this.$v.$reset();
    },
  },
};
</script>
<template>
  <div class="row">
    <div class="col-12">
      <form action="#" @submit.prevent="typeForm">
        <div class="card details-profile-main date-picker-space">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div
                  class="pb-0 page-title-box d-flex align-items-center justify-content-between icon-main-page"
                >
                  <h4 class="card-title page-title-left">
                    Bookings ({{ upComingBookingCount }})
                  </h4>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row justify-content-end">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <div class="date-range-list">
                        <label>Per Page :</label>
                        <select
                          class="custom-select"
                          v-model="perPages"
                          @change="searchData()"
                        >
                          <option value="5" selected>5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5">
                    <div class="date-range-list">
                      <label>Search :</label>
                      <div class="text-sm-right">
                        <div class="search-box mr-2 d-inline-block">
                          <div class="position-relative">
                            <input
                              type="text"
                              class="form-control"
                              id="search"
                              @input="searchData()"
                              v-model="search"
                              :placeholder="$t('navbar.search.text')"
                            />
                            <i class="bx bx-search-alt search-icon"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-md-12">
              <span style="color: red"
                ><b>Note: </b>*If booking start time is less than 60 mins of current time
                then booking will not be cancel.</span
              >
            </div> -->
            <div class="row">
              <div class="col-md-12">
                <b-table
                  striped
                  hover
                  :update:sortBy="sortBy"
                  :update:sortDesc="sortDesc"
                  :no-local-sorting="true"
                  @sort-changed="sortingChanged"
                  :items="getAllUpcomingBooking"
                  :fields="fields"
                  :busy="loading"
                  class="upc-booking-table-class"
                >
                  <template #table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>{{ $t(" Loading") }}</strong>
                    </div>
                  </template>
                  <template v-slot:cell(station)="items">
                    {{ items.item.station ? items.item.station : "" }}
                  </template>
                  <template v-slot:cell(users)="items">
                    <!-- {{ items.item.users ? items.item.users : "" }} -->
                    <RouterLink
                      v-if="items.item.users"
                      :to="{
                        name: 'user-view',
                        params: { id: base64(items.item.user_id) },
                      }"
                    >
                      {{ items.item.users }}
                    </RouterLink>
                  </template>
                  <template v-slot:cell(start_time)="items">
                    {{
                      formatIST(items.item.start_time)
                    }}
                  </template>
                  <template v-slot:cell(end_time)="items">
                    {{
                      formatIST(items.item.end_time)
                    }}
                  </template>
                  <template v-slot:cell(is_cancel)="items">
                    <form>
                      <div class="position-relative">
                        <label class="switch">
                          <input
                            type="checkbox"
                            :id="'is_cancel' + items.item.id"
                            :v-model="booking.is_cancel[items.item.id]"
                            class="switch-on"
                            true-value="1"
                            :name="'is_cancel' + items.item.id"
                            false-value="0"
                            :value="items.item.id"
                            @change="onStatusChange"
                          />
                          <!-- :disabled="items.item.diff_min < '60'" -->
                          <div class="slider round"></div>
                        </label>
                      </div>
                    </form>
                  </template>
                  <template v-slot:cell(info)="items">
                    <b-button
                      @click="getBookingInfo(items.item.id)"
                      class="btn btn-success btn-rounded"
                    >
                      <i class="bx bxs-info-circle"></i>
                    </b-button>
                  </template>
                </b-table>
                <tr
                  v-if="loading == false && getAllUpcomingBooking.length === 0"
                >
                  <td colspan="100%">
                    <h6 align="center">No Upcoming Booking Found</h6>
                  </td>
                </tr>
              </div>
              <div class="row col-sm-5 offset-sm-7">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-right"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <pagination
                        :data="pagination"
                        :limit="limit"
                        @pagination-change-page="getUpcomingBookings"
                      ></pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <b-modal
      v-if="getAllBookingInfo"
      id="bv-modal-booking-info"
      size="lg"
      hide-footer
      @hidden="resetForm"
    >
      <template #modal-title
        >#{{ getAllBookingInfo.id }} Booking Info
        <span
          v-if="getAllBookingInfo.booking_type"
          class="badge badge-pill badge-secondary"
          >{{
            getAllBookingInfo.booking_type.charAt(0).toUpperCase() +
            getAllBookingInfo.booking_type.slice(1)
          }}</span
        ></template
      >
      <form action="#" @submit.prevent="submitEditForm">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Booking User Name :
                {{
                  getAllBookingInfo.users
                    ? getAllBookingInfo.users.full_name
                    : "User Deleted"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Email :
                {{
                  getAllBookingInfo.users && getAllBookingInfo.users.email
                    ? getAllBookingInfo.users.email
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Mobile Number :
                {{
                  getAllBookingInfo.users &&
                  getAllBookingInfo.users.mobile_number
                    ? getAllBookingInfo.users.mobile_number
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Charging Station :
                {{
                  getAllBookingInfo.chargers
                    ? getAllBookingInfo.chargers.name
                    : "Charger Deleted"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Charging Station Address :
                {{
                  getAllBookingInfo.chargers
                    ? getAllBookingInfo.chargers.address
                    : "User Deleted"
                }}</label
              >
            </div>
          </div>
          <template
            v-if="
              getAllBookingInfo.chargers && getAllBookingInfo.chargers.users
            "
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Charger Owner Name :
                  {{ getAllBookingInfo.chargers.users.full_name }}</label
                >
              </div>
            </div>
          </template>
          <template
            v-if="
              getAllBookingInfo &&
              getAllBookingInfo.start_time &&
              getAllBookingInfo.end_time
            "
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Booking Start - Booking End Time :
                  {{ formatIST(getAllBookingInfo.start_time) }} -
                  {{ formatIST(getAllBookingInfo.end_time) }}</label
                >
              </div>
            </div>
          </template>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Pre Auth Transaction Id :
                {{
                  getAllBookingInfo.pre_auth_transaction_id
                    ? getAllBookingInfo.pre_auth_transaction_id
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Pre Auth Charge :
                {{
                  getAllBookingInfo.pre_auth_charge
                    ? getAllBookingInfo.pre_auth_charge
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Final Transaction Id :
                {{
                  getAllBookingInfo.final_transaction_id
                    ? getAllBookingInfo.final_transaction_id
                    : "-"
                }}</label
              >
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-3">
              <label
                >Final Charge :
                {{
                  getAllBookingInfo.final_charge
                    ? getAllBookingInfo.final_charge
                    : "-"
                }}</label
              >
            </div>
          </div>
          <template
            v-if="
              getAllBookingInfo.charging_history &&
              getAllBookingInfo.charging_history.charging_start_time
            "
          >
            <div class="col-sm-4">
              <div class="form-group mb-3">
                <label
                  >Charging Start - Charging End Time :
                  {{ getAllBookingInfo.charging_history.charging_start_time }} -
                  {{
                    getAllBookingInfo.charging_history.charging_end_time
                  }}</label
                >
              </div>
            </div>
          </template>
        </div>
        <div class="text-end mt-3">
          <button
            type="button"
            @click="
              resetForm();
              $bvModal.hide('bv-modal-booking-info');
            "
            class="btn btn-light"
          >
            Close</button
          >&nbsp;
        </div>
      </form>
    </b-modal>
  </div>
</template>
<style>
.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 27px;
}
#is_cancel {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
.switch input {
  display: none;
}
input:checked + .slider {
  background-color: #34c38f;
}
input + .slider {
  background-color: #34c38f;
}
.slider.round {
  border-radius: 34px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: 0.4s;
}
input.switch-on:checked + .slider:before {
  transform: translateX(28px);
}
.slider.round:before {
  border-radius: 50%;
}
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
}
input:checked + .slider .on {
  display: block;
}
.switch .on {
  left: 30%;
}
.switch .on,
.switch .off {
  color: white;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  font-size: 10px;
  font-family: Verdana, sans-serif;
}
input:checked + .slider .off {
  display: none;
}
.switch .off {
  left: 70%;
}
.card.date-picker-space {
  margin-bottom: 100px;
}
.upc-booking-table-class {
  table-layout: fixed;
}
.upc-booking-table-class th:first-child {
  width: 50px;
}
.upc-booking-table-class th:nth-child(2n) {
  width: 200px;
}
.upc-booking-table-class th:nth-child(3n) {
  width: 120px;
}
.upc-booking-table-class th:nth-child(4n) {
  width: 120px;
}
.upc-booking-table-class th:nth-child(5n) {
  width: 120px;
}
.upc-booking-table-class th:nth-child(6n) {
  width: 150px;
}
.upc-booking-table-class th:nth-child(8n) {
  width: 100px;
}
</style>
